import { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import {
  FaApple,
  FaArrowsRotate,
  FaBolt,
  FaBus,
  FaCar,
  FaCarSide,
  FaClipboardCheck,
  FaCartShopping,
  FaFileSignature,
  FaGift,
  FaGooglePlay,
  FaLock,
  FaMagnifyingGlass,
  FaMotorcycle,
  FaShieldHalved,
  FaStar,
  FaTruck,
  FaWallet,
} from "react-icons/fa6";
import "../AllRider/allRider.css";
import "../style01.css";
import "../style02.css";
import "../AllMetuaaEat/metuaaEat.css";
import "./metuaaBuy.css";
import Header from "../../../components/header";
import Footer from "../../../components/footer";
import voiture1 from "../../../assets/images/voiture1.png";
import voiture2 from "../../../assets/images/voiture2.png";
import carBanner from "../../../assets/images/car-banner.png";
import camry from "../../../assets/images/camry-2020.png";
import carnival from "../../../assets/images/New-2025-Kia-Carnival-6.avif";
import classique from "../../../assets/images/classique.png";
import premium from "../../../assets/images/premium.png";
import offer_1 from "../../../assets/images/offer_1.png";
import offer_2 from "../../../assets/images/offer_2.png";

const heroTransitionTypes = ["fade", "slide-left", "slide-right", "square"];

const buySlides = [
  {
    src: voiture1,
    alt: "Véhicule mis en vente sur Metua'a Buy",
    title1Id: "buy.slide1.title1",
    title2Id: "buy.slide1.title2",
    descriptionId: "buy.slide1.description",
  },
  {
    src: carBanner,
    alt: "Voitures neuves et d'occasion sur Metua'a Buy",
    title1Id: "buy.slide2.title1",
    title2Id: "buy.slide2.title2",
    descriptionId: "buy.slide2.description",
  },
];

const buyFilters = [
  { id: "all", label: "buy.categories.all", icon: FaCarSide },
  { id: "cars", label: "buy.categories.cars", icon: FaCar },
  { id: "moto", label: "buy.categories.moto", icon: FaMotorcycle },
  { id: "bus", label: "buy.categories.bus", icon: FaBus },
  { id: "truck", label: "buy.categories.truck", icon: FaTruck },
  { id: "electric", label: "buy.categories.electric", icon: FaBolt },
];

const featuredVehicles = [
  { key: "vehicle1", image: camry, nameId: "buy.featured.vehicle1" },
  { key: "vehicle2", image: carnival, nameId: "buy.featured.vehicle2" },
  { key: "vehicle3", image: classique, nameId: "buy.featured.vehicle3" },
  { key: "vehicle4", image: premium, nameId: "buy.featured.vehicle4" },
];

const buySteps = [
  { key: "choose", icon: FaMagnifyingGlass, titleId: "buy.steps.choose.title", textId: "buy.steps.choose.text" },
  { key: "inspect", icon: FaClipboardCheck, titleId: "buy.steps.inspect.title", textId: "buy.steps.inspect.text" },
  { key: "buy", icon: FaFileSignature, titleId: "buy.steps.buy.title", textId: "buy.steps.buy.text" },
];

const buyFeatures = [
  { key: "checked", icon: FaShieldHalved, titleId: "buy.features.checked.title", textId: "buy.features.checked.text" },
  { key: "finance", icon: FaWallet, titleId: "buy.features.finance.title", textId: "buy.features.finance.text" },
  { key: "tradein", icon: FaArrowsRotate, titleId: "buy.features.tradein.title", textId: "buy.features.tradein.text" },
  { key: "payment", icon: FaLock, titleId: "buy.features.payment.title", textId: "buy.features.payment.text" },
];

function ChevronLeftIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 32 32" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
      <path d="m12.843 25.836 1.585-1.608L7.32 17.12H29v-2.256H7.321l7.107-7.13-1.585-1.585L3 15.993l9.843 9.843z" />
    </svg>
  );
}

function ChevronRightIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 32 32" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
      <path d="m19.157 6.15-1.584 1.608 7.106 7.107H3v2.256h21.679l-7.106 7.13 1.584 1.585L29 15.993 19.157 6.15z" />
    </svg>
  );
}

function SubscriptionShieldIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        d="M12 3l6 2.2v5.5c0 4.3-2.7 7.9-6 9.8-3.3-1.9-6-5.5-6-9.8V5.2L12 3z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M8.9 12.2l2.1 2.1 4.2-4.7"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SubscriptionBadgeIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        d="M12 3.5l1.9 3.9 4.3.6-3.1 3 0.7 4.3L12 13.6 8.2 15.3l0.7-4.3-3.1-3 4.3-.6L12 3.5z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M12 15.3v5.2"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M9.8 20.5h4.4"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

function SubscriptionHeadsetIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        d="M4.5 13a7.5 7.5 0 0 1 15 0"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M4.5 13v3.2c0 .9.7 1.6 1.6 1.6h1.1V13"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5 13v3.2c0 .9-.7 1.6-1.6 1.6h-1.1V13"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.2 18v1.4c0 1.2-1 2.2-2.2 2.2h-1"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M14 21.6h-1.2"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

function SubscriptionRefreshIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        d="M18.5 8.2A7.5 7.5 0 0 0 6 6.3"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M6 4.7v2.1H3.9"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 15.8A7.5 7.5 0 0 0 18 17.7"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M18 19.3v-2.1h2.1"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
const IconArrowRight = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M9.652 2.65 8.426 3.876l3.258 3.258H1v1.728h10.684L8.426 12.12l1.226 1.226L15 7.998 9.652 2.65z" />
  </svg>
);

export default function AllMetuaaBuy() {
  const intl = useIntl();
  const t = (id, values) => intl.formatMessage({ id }, values);
  const [heroIndex, setHeroIndex] = useState(0);
  const [heroPrevIndex, setHeroPrevIndex] = useState(0);
  const [heroTransition, setHeroTransition] = useState("fade");
  const [isHeroPaused, setIsHeroPaused] = useState(false);
  const [activeBuyFilter, setActiveBuyFilter] = useState("all");
  const heroTimerRef = useRef(null);

  const goToHeroSlide = (updater) => {
    const type = heroTransitionTypes[Math.floor(Math.random() * heroTransitionTypes.length)];
    setHeroTransition(type);
    setHeroIndex(updater);
  };

  useEffect(() => {
    if (isHeroPaused || buySlides.length <= 1) return;
    heroTimerRef.current = setInterval(() => {
      goToHeroSlide((prev) => (prev + 1) % buySlides.length);
    }, 5000);
    return () => clearInterval(heroTimerRef.current);
  }, [isHeroPaused]);

  useEffect(() => {
    if (heroPrevIndex === heroIndex) return;
    const id = setTimeout(() => setHeroPrevIndex(heroIndex), 900);
    return () => clearTimeout(id);
  }, [heroIndex, heroPrevIndex]);

  const hasMultipleSlides = buySlides.length > 1;

  return (
    <div id="__next">
      <span data-testid="core-ui-theme-provider" className="sc-dGCmGc cukWQg">
        <Header />

        <main className="metuaa-buy-page">

         

          {/* ══════════════════ HERO SLIDE ══════════════════ */}
          <section
            data-testid="buy-hero-slider"
            className="eats-slider buy-slider"
            onMouseEnter={() => setIsHeroPaused(true)}
            onMouseLeave={() => setIsHeroPaused(false)}
          >
            <img src={buySlides[heroPrevIndex].src} alt={buySlides[heroPrevIndex].alt} className="eats-slider__layer" />

            {heroIndex !== heroPrevIndex && (
              <img
                key={heroIndex}
                src={buySlides[heroIndex]?.src}
                alt={buySlides[heroIndex]?.alt}
                className={`eats-slider__layer eats-slider__anim hero-anim-${heroTransition}`}
              />
            )}

            <div className="eats-slider__overlay" aria-hidden="true" />

            <div className="eats-slider__content">
              <div key={heroIndex} className={`hero-slide-anim hero-anim-${heroTransition}`}>
                <h1 className="eats-slider__title">
                  {t(buySlides[heroIndex]?.title1Id)}{" "}
                  <span>{t(buySlides[heroIndex]?.title2Id)}</span>
                </h1>
                <p className="eats-slider__desc">{t(buySlides[heroIndex]?.descriptionId)}</p>
                <div className="eats-slider__search">
                  <span className="eats-slider__search-icon">
                    <FaMagnifyingGlass />
                  </span>
                  <input type="text" placeholder={t("buy.search.placeholder")} />
                  <button type="button">{t("buy.search.button")}</button>
                </div>
                <div className="hero-btn-group">
                  <a href="#featured" className="eats-slider__cta eats-slider__cta--outline">
                    {t("buy.slide1.cta.browse")}
                  </a>
                  <a href="/signup-passenger" className="btn-secondary-outline">
                    {t("buy.slide1.cta.sell")}
                  </a>
                </div>
              </div>
            </div>

            {hasMultipleSlides && (
              <>
                <button
                  type="button"
                  className="eats-slider__arrow eats-slider__arrow--prev"
                  aria-label={t("buy.slide.prev")}
                  onClick={() => goToHeroSlide((prev) => (prev - 1 + buySlides.length) % buySlides.length)}
                >
                  <ChevronLeftIcon />
                </button>
                <button
                  type="button"
                  className="eats-slider__arrow eats-slider__arrow--next"
                  aria-label={t("buy.slide.next")}
                  onClick={() => goToHeroSlide((prev) => (prev + 1) % buySlides.length)}
                >
                  <ChevronRightIcon />
                </button>
                <div className="eats-slider__dots">
                  {buySlides.map((_, i) => (
                    <button
                      key={i}
                      type="button"
                      aria-label={t("buy.slide.dot", { index: i + 1 })}
                      className={`eats-slider__dot${i === heroIndex ? " is-active" : ""}`}
                      onClick={() => goToHeroSlide(() => i)}
                    />
                  ))}
                </div>
              </>
            )}
          </section>

           {/* ══════════════════ SECTION SOUSCRIPTION ══════════════════ */}
          <section
            aria-labelledby="buy-subscription-title"
            style={{
              background:
                "radial-gradient(circle at top center, rgba(186, 241, 205, 0.24) 0%, rgba(255, 255, 255, 0.96) 34%, #ffffff 72%)",
              padding: "72px 20px 54px",
            }}
          >
            <div style={{ maxWidth: 1400, margin: "0 auto" }}>
              <div style={{ textAlign: "center", marginBottom: 34 }}>
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "8px 18px",
                    borderRadius: 999,
                    background: "rgba(12, 111, 63, 0.10)",
                    color: "#0c6f3f",
                    fontSize: 16,
                    fontWeight: 800,
                    fontFamily: "'RebelSansText', sans-serif",
                    letterSpacing: "0.02em",
                    textTransform: "uppercase",
                    marginBottom: 18,
                  }}
                >
                  Nos programmes de souscription
                </div>

                <h1
                  id="buy-subscription-title"
                  style={{
                    margin: 0,
                    color: "#132238",
                    fontFamily: "'RebelSansDisplay', sans-serif",
                    fontSize: "2.9rem",
                    lineHeight: 1,
                    fontWeight: 700,
                    letterSpacing: "-0.04em",
                  }}
                >
                  Des produits pensés pour
                  <br />
                  vous accompagner <span style={{ color: "#2da56a" }}>au quotidien</span>
                </h1>

                <p
                  style={{
                    maxWidth: 820,
                    margin: "18px auto 0",
                    color: "#556072",
                    fontFamily: "'RebelSansText', sans-serif",
                    fontSize: "clamp(1.05rem, 1.8vw, 1.5rem)",
                    lineHeight: 1.55,
                    fontWeight: 400,
                  }}
                >
                  Choisissez le programme qui correspond à vos besoins et profitez d'avantages exclusifs à chaque étape.
                </p>
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
                  gap: 24,
                  marginBottom: 28,
                }}
              >
                {[
                  { icon: SubscriptionShieldIcon, title: "100% Sécurisé", text: "Transactions protégées" },
                  { icon: SubscriptionBadgeIcon, title: "Qualité garantie", text: "Produits et services fiables" },
                  { icon: SubscriptionHeadsetIcon, title: "Support dédié", text: "Assistance à votre écoute" },
                  { icon: SubscriptionRefreshIcon, title: "Flexible", text: "Résiliez ou changez à tout moment" },
                ].map(({ icon: Icon, title, text }) => (
                  <div
                    key={title}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 14,
                      justifyContent: "center",
                      color: "#132238",
                      fontFamily: "'RebelSansText', sans-serif",
                    }}
                  >
                    <span
                      style={{
                        width: 42,
                        height: 42,
                        borderRadius: 999,
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#2da56a",
                        background: "transparent",
                        flex: "0 0 42px",
                      }}
                    >
                      <Icon aria-hidden="true" />
                    </span>
                    <div>
                      <div
                        style={{
                          fontSize: 18,
                          fontWeight: 800,
                          lineHeight: 1.2,
                          fontFamily: "'RebelSansText', sans-serif",
                        }}
                      >
                        {title}
                      </div>
                      <div
                        style={{
                          fontSize: 15,
                          color: "#5e6978",
                          marginTop: 4,
                          fontWeight: 400,
                          fontFamily: "'RebelSansText', sans-serif",
                        }}
                      >
                        {text}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
                  gap: 22,
                }}
              >
                {[
                  {
                    accent: "#1f8f57",
                    tag: "Pack Essentiel",
                    image: voiture1,
                    desc: "L'essentiel pour bien démarrer.",
                    features: ["Accès aux fonctionnalités de base", "Mises à jour régulières", "Support par email"],
                    price: "5 000 FCFA",
                    priceHint: "/ mois",
                    cta: "Souscrire",
                    ctaStyle: { background: "#ffffff", color: "#1f8f57", border: "1.5px solid #7fd0a2" },
                  },
                  {
                    accent: "#1e63c8",
                    tag: "Pack Avancé",
                    image: voiture2,
                    desc: "Plus de puissance, plus de possibilités.",
                    features: ["Toutes les fonctionnalités Essentiel", "Fonctionnalités avancées", "Rapports et analyses", "Support prioritaire"],
                    price: "15 000 FCFA",
                    priceHint: "/ mois",
                    cta: "Souscrire",
                    ctaStyle: { background: "#ffffff", color: "#1e63c8", border: "1.5px solid #7ca8ef" },
                  },
                  {
                    accent: "#7a3acb",
                    tag: "Pack Premium",
                    image: premium,
                    badge: "PLUS POPULAIRE",
                    desc: "L'expérience complète sans limites.",
                    features: ["Toutes les fonctionnalités Avancé", "Accès illimité", "Personnalisation avancée", "Support prioritaire 24/7", "Accompagnement dédié"],
                    price: "30 000 FCFA",
                    priceHint: "/ mois",
                    cta: "Souscrire",
                    ctaStyle: { background: "linear-gradient(135deg, #7a3acb 0%, #6a2fc2 100%)", color: "#ffffff", border: "none" },
                  },
                  {
                    accent: "#ef6c11",
                    tag: "Pack Enterprise",
                    image: carBanner,
                    desc: "Conçu pour les équipes et entreprises.",
                    features: ["Toutes les fonctionnalités Premium", "Gestion multi-utilisateurs", "Outils collaboratifs", "Intégrations avancées", "Account manager dédié"],
                    price: "Sur devis",
                    priceHint: "Contactez-nous",
                    cta: "Nous contacter",
                    ctaStyle: { background: "#ffffff", color: "#ef6c11", border: "1.5px solid #ffb27f" },
                  },
                ].map((card) => (
                  <article
                    key={card.tag}
                      style={{
                        background: "#ffffff",
                        borderRadius: 22,
                        overflow: "hidden",
                        boxShadow: "0 12px 30px rgba(14, 24, 38, 0.10)",
                        border: "1px solid rgba(17, 24, 39, 0.06)",
                        display: "flex",
                        flexDirection: "column",
                        minHeight: 640,
                        fontFamily: "'RebelSansText', sans-serif",
                      }}
                    >
                    <div style={{ position: "relative", height: 210, overflow: "hidden" }}>
                      {card.badge ? (
                        <div
                          style={{
                            position: "absolute",
                            top: 16,
                            left: "50%",
                            transform: "translateX(-50%)",
                            zIndex: 2,
                            padding: "7px 14px",
                            borderRadius: 999,
                            background: "#7a3acb",
                            color: "#ffffff",
                            fontSize: 13,
                            fontWeight: 800,
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 8,
                            boxShadow: "0 8px 18px rgba(122, 58, 203, 0.28)",
                          }}
                        >
                          <FaStar aria-hidden="true" />
                          {card.badge}
                        </div>
                      ) : null}
                      <img
                        src={card.image}
                        alt={card.tag}
                        style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                      />
                    </div>
                    <div
                      style={{
                        position: "relative",
                        marginTop: -32,
                        marginLeft: 20,
                        width: 68,
                        height: 68,
                        borderRadius: 18,
                        background: "#ffffff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: card.accent,
                        boxShadow: "0 10px 24px rgba(15, 23, 42, 0.12)",
                      }}
                      >
                        <FaCarSide aria-hidden="true" size={28} />
                      </div>
                      <div style={{ padding: "16px 22px 22px", display: "flex", flexDirection: "column", flex: 1 }}>
                      <h3
                        style={{
                          margin: "6px 0 8px",
                          color: card.accent,
                          fontSize: 26,
                          lineHeight: 1.05,
                          fontWeight: 700,
                          fontFamily: "'RebelSansDisplay', sans-serif",
                          letterSpacing: "-0.02em",
                        }}
                      >
                        {card.tag}
                      </h3>
                      <p
                        style={{
                          margin: 0,
                          color: "#556072",
                          fontSize: 16,
                          lineHeight: 1.45,
                          fontWeight: 400,
                        }}
                      >
                        {card.desc}
                      </p>
                      <ul style={{ listStyle: "none", padding: 0, margin: "18px 0 0", display: "grid", gap: 10 }}>
                        {card.features.map((feature) => (
                          <li
                            key={feature}
                            style={{
                              display: "flex",
                              gap: 10,
                              color: "#3f4a59",
                              fontSize: 15,
                              lineHeight: 1.4,
                              fontWeight: 400,
                            }}
                          >
                            <span style={{ color: card.accent, flex: "0 0 auto" }}>✓</span>
                            <span>{feature}</span>
                          </li>
                        ))}
                      </ul>
                      <div style={{ marginTop: "auto", paddingTop: 24 }}>
                        <div
                          style={{
                            color: "#556072",
                            fontSize: 16,
                            fontWeight: 400,
                          }}
                        >
                          À partir de
                        </div>
                        <div
                          style={{
                            color: card.accent,
                            fontSize: 30,
                            fontWeight: 700,
                            lineHeight: 1.05,
                            marginTop: 6,
                            fontFamily: "'RebelSansDisplay', sans-serif",
                            letterSpacing: "-0.02em",
                          }}
                        >
                          {card.price}
                        </div>
                        <div style={{ color: "#556072", fontSize: 15, fontWeight: 400 }}>{card.priceHint}</div>
                        <button
                          type="button"
                          style={{
                            width: "100%",
                            marginTop: 18,
                            minHeight: 52,
                            borderRadius: 12,
                            fontSize: 16,
                            fontWeight: 700,
                            fontFamily: "'RebelSansText', sans-serif",
                            cursor: "pointer",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 10,
                            ...card.ctaStyle,
                          }}
                        >
                          <FaCartShopping aria-hidden="true" />
                          {card.cta}
                        </button>
                      </div>
                    </div>
                  </article>
                ))}
              </div>

              <div
                style={{
                  marginTop: 26,
                  borderRadius: 18,
                  padding: "18px 22px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 18,
                  background: "linear-gradient(90deg, rgba(12,111,63,0.08) 0%, rgba(12,111,63,0.04) 100%)",
                  border: "1px solid rgba(12,111,63,0.10)",
                  boxShadow: "0 10px 24px rgba(15, 23, 42, 0.05)",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                  <div
                    style={{
                      width: 54,
                      height: 54,
                      borderRadius: 999,
                      background: "#2da56a",
                      color: "#ffffff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flex: "0 0 54px",
                    }}
                  >
                    <FaGift aria-hidden="true" />
                  </div>
                  <div>
                    <div
                      style={{
                        fontSize: 18,
                        fontWeight: 700,
                        color: "#1b6b42",
                        fontFamily: "'RebelSansDisplay', sans-serif",
                      }}
                    >
                      Offre spéciale lancement
                    </div>
                    <div
                      style={{
                        fontSize: 15,
                        color: "#556072",
                        marginTop: 4,
                        fontWeight: 400,
                        fontFamily: "'RebelSansText', sans-serif",
                      }}
                    >
                      Bénéficiez de -20% sur tous les packs pour toute souscription avant le 30 septembre 2025.
                    </div>
                  </div>
                </div>
                <a
                  href="#"
                  style={{
                    color: "#1b6b42",
                    fontWeight: 700,
                    fontFamily: "'RebelSansText', sans-serif",
                    textDecoration: "none",
                    whiteSpace: "nowrap",
                  }}
                >
                  Profiter de l'offre →
                </a>
              </div>
            </div>
          </section>

          {/* ══════════════════ CATÉGORIES ══════════════════ */}
          <section className="food-filters-section" aria-label="Catégories de véhicules">
            <div className="filters-scroll">
              {buyFilters.map(({ id, label, icon: Icon }) => (
                <button
                  key={id}
                  type="button"
                  className={`filter-chip${activeBuyFilter === id ? " active" : ""}`}
                  aria-pressed={activeBuyFilter === id}
                  onClick={() => setActiveBuyFilter(id)}
                >
                  <Icon aria-hidden="true" />
                  {t(label)}
                </button>
              ))}
            </div>
          </section>

          {/* ══════════════════ VÉHICULES EN VEDETTE ══════════════════ */}
          <section className="top-partners-section" aria-labelledby="buy-featured-title">
            <div className="page-shell">
              <h2 id="buy-featured-title" className="top-partners-title">
                {t("buy.featured.title")} <mark>{t("buy.featured.titleMark")}</mark>
              </h2>
              <div className="top-partners-grid">
                {featuredVehicles.map((vehicle) => (
                  <article key={vehicle.key} className="top-partner-card">
                    <div className="top-partner-image">
                      <img src={vehicle.image} alt={t(vehicle.nameId)} loading="lazy" decoding="async" />
                    </div>
                    <span className="top-partner-name">{t(vehicle.nameId)}</span>
                  </article>
                ))}
              </div>
            </div>
          </section>

          {/* ══════════════════ COMMENT ÇA MARCHE ══════════════════ */}
          <section className="how-it-works-section" data-qa="how-it-works-section">
            <div className="how-it-works-content">
              <h3 className="how-it-works-eyebrow">{t("buy.steps.eyebrow")}</h3>
              <h2 className="how-it-works-title">{t("buy.steps.title")}</h2>
              <div className="how-it-works-grid">
                {buySteps.map((step) => (
                  <article key={step.key} className="how-it-works-card">
                    <step.icon aria-hidden="true" className="how-it-works-icon" />
                    <h5 className="how-it-works-card-title">{t(step.titleId)}</h5>
                    <p className="how-it-works-card-text">{t(step.textId)}</p>
                  </article>
                ))}
              </div>
            </div>
          </section>

          {/* ══════════════════ FEATURES ══════════════════ */}
          <section className="feature-cards-section">
            <div className="page-shell">
              <h2 className="feature-cards-title">{t("buy.features.title")}</h2>
              <div className="feature-cards-grid">
                {buyFeatures.map((card) => (
                  <article key={card.key} className="feature-card">
                    <card.icon aria-hidden="true" className="feature-card-icon" />
                    <h3>{t(card.titleId)}</h3>
                    <p>{t(card.textId)}</p>
                  </article>
                ))}
              </div>
            </div>
          </section>

          {/* ══════════════════ BANNER PROGRAMME M+ ══════════════════ */}
          <section className="corporate-section buy-banner-section">
            <h1 className="corporate-title">{t("buy.banner.title1")}</h1>
            <section className="corporate-banner">
              <div className="corporate-text">
                <h2>
                  {t("buy.banner.title2")} <span>{t("buy.banner.title3")}</span>
                </h2>
                <p>{t("buy.banner.text")}</p>
              </div>
              <div className="corporate-action">
                <a className="corporate-action-link" href="/mplus-program">
                  {t("buy.banner.cta")}
                </a>
              </div>
            </section>
          </section>

          {/* ══════════════════ OFFERS ══════════════════ */}
          <section
            className="all-page-section sc-cd975d71-0 fJfYVy sc-4d039203-0 iaLMvL"
            data-tracking-label="Homepage > Brand Redesign Jun 2025 > Metua'a Up"
            data-tracking-action="view"
            data-tracking-category="TextImageModule"
          >
            <div className="sc-eNSrOW kusvag">
              <div
                className="sc-satoz iYojpr"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  gap: "24px",
                  width: "100%",
                }}
              >
                {/* Colonne 1 : Card Package Famille */}
                <div className="offer-card-col">
                  <div className="cardOffer" style={{ backgroundImage: `url(${offer_1})` }}>
                    <div className="cardOffer-overlay">
                      <p className="cardOffer-label">{t("home.offers.family.label")}</p>
                      <h3 className="cardOffer-title">{t("home.offers.family.title")}</h3>
                      <div className="cardOffer-code">
                        <span className="cardOffer-code-label">{t("home.offers.codeLabel")}</span>
                        <span className="cardOffer-code-value">{t("home.offers.codeValue")}</span>
                      </div>
                      <button className="cardOffer-button">
                        {t("home.offers.discover")}
                        <IconArrowRight />
                      </button>
                    </div>
                  </div>
                </div>

                {/* Colonne 2 : Card Package Entreprise */}
                <div className="offer-card-col">
                  <div className="cardOffer" style={{ backgroundImage: `url(${offer_2})` }}>
                    <div className="cardOffer-overlay">
                      <p className="cardOffer-label">{t("home.offers.business.label")}</p>
                      <h3 className="cardOffer-title">{t("home.offers.business.title")}</h3>
                      <div className="cardOffer-code">
                        <span className="cardOffer-code-label">{t("home.offers.codeLabel")}</span>
                        <span className="cardOffer-code-value">{t("home.offers.codeValue")}</span>
                      </div>
                      <button type="button" className="cardOffer-button">
                        <span>{t("home.offers.discover")}</span>
                        <IconArrowRight />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* ══════════════════ TÉLÉCHARGER L'APPLI ══════════════════ */}
          <section className="download-app-section" data-qa="download-app-section">
            <div className="page-shell">
              <div className="download-app-layout">
                <div className="download-app-info">
                  <h3 className="download-app-title">{t("buy.download.title")}</h3>
                  <p className="download-app-subtitle">{t("buy.download.subtitle")}</p>
                  <div className="download-app-stores">
                    <a className="store-badge" href="#" aria-label="Accéder à iOS App Store">
                      <FaApple aria-hidden="true" />
                      <span>App Store</span>
                    </a>
                    <a className="store-badge" href="#" aria-label="Accéder à Google Play Store">
                      <FaGooglePlay aria-hidden="true" />
                      <span>Google Play</span>
                    </a>
                  </div>
                </div>
                <div className="download-app-visual">
                  <img src={voiture2} alt="Aperçu de l'application Metua'a Buy" loading="lazy" decoding="async" />
                </div>
              </div>
            </div>
          </section>

        </main>

        <Footer />
      </span>
    </div>
  );
}
